module.exports = __webpack_public_path__ + "media/images/writer/story_achievement_mailer/ogp_image_rank_no4-56d441edbd597bbd6c286327d4b45f12.png";